import {
  getFavoritesNewItemsAction,
  getUserLocationsAction,
  loadArticleAction,
  loadBackpackContentAction,
  loadLibContentAction,
  loadLibFiltersAction,
  loadMaterialsContentAction,
  loadMaterialsTemplatesAction,
  loadPublicArticleAction,
  loadResourceContentAction,
  loadResourceFiltersAction,
  saveJournalAction,
  sendMaterialsAction
} from './content/contentAsyncActions';
import {
  addBotToDialogueAction,
  addUsersToDialogueAction,
  addUserToDialogueAction,
  blockParticipantAction,
  createDialogueAction,
  loadBotsAction,
  loadDialogueAction,
  loadDialogueParticipantAction,
  loadDialogueParticipantsAction,
  loadDialoguesAction,
  loadXpeditionsAction,
  removeDialogueAction,
  removeParticipantFromDialogueAction,
  restartXpeditionAction,
  setDialogueNameAction,
  startXpeditionAction,
  unlockParticipantAction
} from './dialogue/dialogueAsyncActions';
import {
  loadTeiArticleAction,
  loadTeiArticleAuthorsAction, loadTeiArticleCollectionsAction,
  loadTeiArticleReferenceAction,
  loadTeiArticleReferencesAction,
  loadTeiArticleSectionAction,
  loadTeiArticleSectionsAction, loadTeiArticleTablesAction,
  loadTeiReferenceAuthorsAction
} from './article/articleAsyncActions';
import {
  createJournalAction,
  editJournalAction,
  getJournalAction,
  loadJournalsAction,
  removeJournalAction
} from './journal/journalAsyncActions';
import {
  loadJournalStatsAction,
  loadJournalStatValueAction
} from './journal-stats/journalStatsAsyncActions';
import {
  createReviewAction,
  editReviewAction,
  getReviewAction,
  loadReviewsAction,
  loadReviewTypesAction,
  removeReviewAction
} from './review/reviewAsyncActions';
import {
  addDialogueToFavoritesAction,
  createChatroomDialogueAction,
  loadChatroomDialoguesAction,
  removeDialogueFromFavoritesAction
} from './chatroom/chatroomAsyncActions';
import {
  addCmServiceToFavoritesAction,
  addReferralsAction,
  loadCmCountyFiltersAction,
  loadCmFiltersAction,
  loadCmServiceAction,
  loadCmServicesAction,
  loadCmServicesOrgAction,
  loadReferralsAction,
  removeCmServiceFromFavoritesAction,
  removeReferralsAction,
  sendReferralsAction
} from './cm-service/cmServiceAsyncActions';
import {
  createSearchDialogueAction,
  editSearchDialogueAction,
  loadSearchDialogueAction,
  loadSearchDialoguesAction,
  removeSearchDialogueAction
} from './search/searchAsyncActions';
import {
  createTrainingDialogueAction,
  editTrainingDialogueAction,
  loadTrainingDialogueAction,
  loadTrainingDialoguesAction,
  removeTrainingDialogueAction
} from './trainings/trainingsAsyncActions';
import {
  loadExerciseDialogueAction,
  loadExerciseDoneAction, loadExerciseStatisticsAction,
  loadExerciseToDoAction
} from './exercise/exerciseAsyncActions';
import {
  loadBotAvatarsAction,
  loadUserAvatarsAction, loadVideoAvatarsAction, sendVerificationEmailAction
} from './auth/userAsyncActions';
import {loadStatisticsAction} from './staistics-dashboard/statisticsDashboardAsyncActions';
import {loadSessionsAction, removeSessionDialogueAction} from './sessions/sessionAsyncActions';
import {loadActivitiesAction, removeActivityDialogueAction} from './activities/activityAsyncActions';
import {
  loadNotificationCountAction,
  loadNotificationsAction,
  markAllNotificationsReadAction,
  markNotificationReadAction,
  resetNotificationsAction
} from './notifications/notificationAsyncActions';

export const getTranslations = 'GET_TRANSLATIONS';
export const getLibFilters = 'GET_LIBRARY_FILTERS';
export const getResourceFilters = 'GET_RESOURCE_FILTERS';
export const getLibContent = 'GET_LIBRARY_CONTENT';
export const getResourceContent = 'GET_RESOURCE_CONTENT';
export const getBackpackContent = 'GET_BACKPACK_CONTENT';
export const getMaterialsContent = 'GET_MATERIALS_CONTENT';
export const getArticle = 'GET_ARTICLE';
export const sendFeedback = 'SEND_FEEDBACK';
export const getTemplates = 'GET_TEMPLATES';
export const sendMaterials = 'SEND_MATERIALS';
export const saveJournal = 'SAVE_JOURNAL';
export const getDialogues = 'GET_DIALOGUES';
export const setDialogueName = 'SET_DIALOGUE_NAME';
export const createDialogue = 'CREATE_DIALOGUE';
export const removeDialogue = 'REMOVE_DIALOGUE';
export const getDialogue = 'GET_DIALOGUE';
export const getDialogueParticipants = 'GET_DIALOGUE_PARTICIPANTS';
export const getDialogueParticipant = 'GET_DIALOGUE_PARTICIPANT';
export const getBots = 'GET_BOTS';
export const addBotToDialogue = 'ADD_BOT_TO_DIALOGUE';
export const addUsersToDialogue = 'ADD_USERS_TO_DIALOGUE';
export const addUserToDialogue = 'ADD_USER_TO_DIALOGUE';
export const removeParticipantFromDialogue = 'REMOVE_PARTICIPANT_FROM_DIALOGUE';
export const blockParticipant = 'BLOCK_PARTICIPANT';
export const unlockParticipant = 'UNLOCK_PARTICIPANT';
export const startXpedition = 'START_XPEDITION';
export const restartXpedition = 'RESTART_XPEDITION';
export const getXpeditions = 'GET_XPEDITIONS';
export const createVideoCall = 'CREATE_VIDEO_CALL';
export const getVideoCallToken = 'GET_VIDEO_CALL_TOKEN';
export const getVideoCallRtmToken = 'GET_VIDEO_CALL_RTM_TOKEN';
export const finishVideoCall = 'FINISH_VIDEO_CALL';
export const getVideoCallActive = 'GET_VIDEO_CALL_ACTIVE';
export const setDialogueLanguage = 'SET_DIALOGUE_LANGUAGE';
export const getPublicArticle = 'GET_PUBLIC_ARTICLE';
export const getTeiArticle = 'GET_TEI_ARTICLE';
export const getTeiArticleAuthors = 'GET_TEI_ARTICLE_AUTHORS';
export const getTeiArticleReferences = 'GET_TEI_ARTICLE_REFERENCES';
export const getTeiArticleReference = 'GET_TEI_ARTICLE_REFERENCE';
export const getTeiArticleSection = 'GET_TEI_ARTICLE_SECTION';
export const getTeiReferenceAuthors = 'GET_TEI_REFERENCE_AUTHORS';
export const getTeiArticleSections = 'GET_TEI_SECTIONS';
export const getTeiArticleCollections = 'GET_TEI_COLLECTIONS';
export const getTeiArticleTables = 'GET_TEI_TABLES';
export const getJournals = 'GET_JOURNALS';
export const getJournal = 'GET_JOURNAL';
export const createJournal = 'CREATE_JOURNAL';
export const editJournal = 'EDIT_JOURNAL';
export const removeJournal = 'REMOVE_JOURNAL';
export const getJournalStats = 'GET_JOURNAL_STATS';
export const getJournalStatValue = 'GET_JOURNAL_STAT_VALUE';
export const getReviewTypes = 'GET_REVIEW_TYPES';
export const getReviews = 'GET_REVIEWS';
export const getReview = 'GET_REVIEW';
export const createReview = 'CREATE_REVIEW';
export const editReview = 'EDIT_REVIEW';
export const removeReview = 'REMOVE_REVIEW';
export const getUserLocations = 'GET_USER_LOCATIONS';
export const getChatroomDialogues = 'GET_CHATROOM_DIALOGUES';
export const createChatroomDialogue = 'CREATE_CHATROOM_DIALOGUE';
export const addDialogueToFavorites = 'ADD_DIALOGUE_TO_FAVORITES';
export const removeDialogueFromFavorites = 'REMOVE_DIALOGUE_FROM_FAVORITES';
export const getCmFilters = 'GET_CM_FILTERS';
export const getCmCountyFilters = 'GET_CM_COUNTY_FILTERS';
export const getCmServices = 'GET_CM_SERVICES';
export const getCmServicesOrg = 'GET_CM_SERVICES_ORG';
export const getCmService = 'GET_CM_SERVICE';
export const cmServiceAddToFavorites = 'CM_SERVICE_ADD_TO_FAVORITES';
export const cmServiceRemoveFromFavorites = 'CM_SERVICE_REMOVE_FROM_FAVORITES';
export const getReferrals = 'CM_SERVICE_GET_REFERRALS';
export const addReferrals = 'ADD_REFERRALS';
export const removeReferrals = 'REFERRALS_REFERRALS';
export const sendReferrals = 'SEND_REFERRALS';
export const getSearchDialogues = 'GET_SEARCH_DIALOGUES';
export const getSearchDialogue = 'GET_SEARCH_DIALOGUE';
export const createSearchDialogue = 'CREATE_SEARCH_DIALOGUE';
export const editSearchDialogue = 'EDIT_SEARCH_DIALOGUE';
export const removeSearchDialogue = 'REMOVE_SEARCH_DIALOGUE';
export const getTrainingDialogues = 'GET_TRAINING_DIALOGUES';
export const getTrainingDialogue = 'GET_TRAINING_DIALOGUE';
export const createTrainingDialogue = 'CREATE_TRAINING_DIALOGUE';
export const editTrainingDialogue = 'EDIT_TRAINING_DIALOGUE';
export const removeTrainingDialogue = 'REMOVE_TRAINING_DIALOGUE';
export const getExerciseToDo = 'GET_EXERCISE_TO_DO';
export const getExerciseDone = 'GET_EXERCISE_DONE';
export const getExerciseDialogue = 'GET_EXERCISE_DIALOGUE';
export const getExerciseStatistics = 'GET_EXERCISE_STATISTICS';
export const getBotAvatars = 'GET_BOT_AVATARS';
export const getVideoAvatars = 'GET_VIDEO_AVATARS';
export const getUserAvatars = 'GET_USER_AVATARS';
export const getUserData = 'GET_USER_DATA';
export const getDashboardStatistics = 'GET_DASHBOARD_STATISTICS';
export const getSiteSettings = 'GET_SITE_SETTINGS';
export const updateProfile = 'UPDATE_PROFILE';
export const updateUserVideoAvatar = 'UPDATE_USER_VIDEO_AVATAR';
export const getUserGroups = 'GET_USER_GROUPS';
export const sendVerificationEmail = 'SEND_VERIFICATION_EMAIL';
export const getSessions = 'GET_SESSIONS';
export const removeSessionDialogue = 'REMOVE_SESSION';
export const getActivities = 'GET_ACTIVITIES';
export const removeActivityDialogue = 'REMOVE_ACTIVITY';
export const getFavoriteNewItems = 'GET_FAVORITE_NEW_ITEMS';
export const getNotifications = 'GET_NOTIFICATIONS';
export const loadMoreNotifications = 'LOAD_MORE_NOTIFICATIONS';
export const markNotificationAsRead = 'MARK_NOTIFICATION_AS_READ';
export const markAllNotificationsAsRead = 'MARK_ALL_NOTIFICATIONS_AS_READ';
export const getNotificationCount = 'GET_NOTIFICATION_COUNT';
export const resetNotifications = 'RESET_NOTIFICATIONS';

export const libraryAsyncActions = {
  [getLibFilters]: loadLibFiltersAction,
  [getLibContent]: loadLibContentAction
};

export const backpackAsyncActions = {
  [getBackpackContent]: loadBackpackContentAction,
  [getFavoriteNewItems]: getFavoritesNewItemsAction
};

export const materialsAsyncActions = {
  [getMaterialsContent]: loadMaterialsContentAction,
  [getTemplates]: loadMaterialsTemplatesAction,
  [sendMaterials]: sendMaterialsAction
};

export const contentAsyncActions = {
  [getArticle]: loadArticleAction,
  [saveJournal]: saveJournalAction,
  [getPublicArticle]: loadPublicArticleAction
};

export const chatAsyncActions = {
  [getArticle]: loadArticleAction
};

export const dialogueAsyncActions = {
  [getDialogues]: loadDialoguesAction,
  [setDialogueName]: setDialogueNameAction,
  [createDialogue]: createDialogueAction,
  [removeDialogue]: removeDialogueAction,
  [getDialogue]: loadDialogueAction,
  [getDialogueParticipants]: loadDialogueParticipantsAction,
  [getDialogueParticipant]: loadDialogueParticipantAction,
  [getBots]: loadBotsAction,
  [addBotToDialogue]: addBotToDialogueAction,
  [addUsersToDialogue]: addUsersToDialogueAction,
  [addUserToDialogue]: addUserToDialogueAction,
  [removeParticipantFromDialogue]: removeParticipantFromDialogueAction,
  [blockParticipant]: blockParticipantAction,
  [unlockParticipant]: unlockParticipantAction,
  [startXpedition]: startXpeditionAction,
  [restartXpedition]: restartXpeditionAction,
  [getXpeditions]: loadXpeditionsAction
};

export const articleAsyncActions = {
  [getTeiArticle]: loadTeiArticleAction,
  [getTeiArticleAuthors]: loadTeiArticleAuthorsAction,
  [getTeiArticleReferences]: loadTeiArticleReferencesAction,
  [getTeiArticleReference]: loadTeiArticleReferenceAction,
  [getTeiReferenceAuthors]: loadTeiReferenceAuthorsAction,
  [getTeiArticleSection]: loadTeiArticleSectionAction,
  [getTeiArticleSections]: loadTeiArticleSectionsAction,
  [getTeiArticleCollections]: loadTeiArticleCollectionsAction,
  [getTeiArticleTables]: loadTeiArticleTablesAction
};

export const journalAsyncActions = {
  [getJournals]: loadJournalsAction,
  [createJournal]: createJournalAction,
  [editJournal]: editJournalAction,
  [removeJournal]: removeJournalAction,
  [getJournal]: getJournalAction
};

export const resourceAsyncActions = {
  [getResourceFilters]: loadResourceFiltersAction,
  [getResourceContent]: loadResourceContentAction,
  [getUserLocations]: getUserLocationsAction
};

export const journalStatsAsyncActions = {
  [getJournalStats]: loadJournalStatsAction,
  [getJournalStatValue]: loadJournalStatValueAction
};

export const reviewAsyncActions = {
  [getReviewTypes]: loadReviewTypesAction,
  [getReviews]: loadReviewsAction,
  [createReview]: createReviewAction,
  [editReview]: editReviewAction,
  [removeReview]: removeReviewAction,
  [getReview]: getReviewAction
};

export const chatroomAsyncActions = {
  [getChatroomDialogues]: loadChatroomDialoguesAction,
  [createChatroomDialogue]: createChatroomDialogueAction,
  [addDialogueToFavorites]: addDialogueToFavoritesAction,
  [removeDialogueFromFavorites]: removeDialogueFromFavoritesAction
};

export const cmServiceAsyncActions = {
  [getCmFilters]: loadCmFiltersAction,
  [getCmCountyFilters]: loadCmCountyFiltersAction,
  [getCmServices]: loadCmServicesAction,
  [getCmService]: loadCmServiceAction,
  [cmServiceAddToFavorites]: addCmServiceToFavoritesAction,
  [cmServiceRemoveFromFavorites]: removeCmServiceFromFavoritesAction,
  [getCmServicesOrg]: loadCmServicesOrgAction
};

export const referralsAsyncActions = {
  [getReferrals]: loadReferralsAction,
  [addReferrals]: addReferralsAction,
  [removeReferrals]: removeReferralsAction,
  [sendReferrals]: sendReferralsAction
};

export const searchAsyncActions = {
  [getSearchDialogues]: loadSearchDialoguesAction,
  [createSearchDialogue]: createSearchDialogueAction,
  [editSearchDialogue]: editSearchDialogueAction,
  [removeSearchDialogue]: removeSearchDialogueAction,
  [getSearchDialogue]: loadSearchDialogueAction
};

export const trainingsAsyncActions = {
  [getTrainingDialogues]: loadTrainingDialoguesAction,
  [createTrainingDialogue]: createTrainingDialogueAction,
  [editTrainingDialogue]: editTrainingDialogueAction,
  [removeTrainingDialogue]: removeTrainingDialogueAction,
  [getTrainingDialogue]: loadTrainingDialogueAction
};

export const exerciseAsyncActions = {
  [getExerciseToDo]: loadExerciseToDoAction,
  [getExerciseDone]: loadExerciseDoneAction,
  [getExerciseDialogue]: loadExerciseDialogueAction,
  [getExerciseStatistics]: loadExerciseStatisticsAction
};

export const authAsyncActions = {
  [getBotAvatars]: loadBotAvatarsAction,
  [getUserAvatars]: loadUserAvatarsAction,
  [sendVerificationEmail]: sendVerificationEmailAction,
  [getVideoAvatars]: loadVideoAvatarsAction
};

export const statisticsDashboardAsyncActions = {
  [getDashboardStatistics]: loadStatisticsAction
};

export const sessionsAsyncActions = {
  [getSessions]: loadSessionsAction,
  [removeSessionDialogue]: removeSessionDialogueAction
};

export const activitiesAsyncActions = {
  [getActivities]: loadActivitiesAction,
  [removeActivityDialogue]: removeActivityDialogueAction
};

export const notificationAsyncActions = {
  [getNotifications]: loadNotificationsAction,
  [loadMoreNotifications]: loadNotificationsAction,
  [markNotificationAsRead]: markNotificationReadAction,
  [markAllNotificationsAsRead]: markAllNotificationsReadAction,
  [getNotificationCount]: loadNotificationCountAction,
  [resetNotifications]: resetNotificationsAction
};

